import PropTypes from 'prop-types';
import React from 'react';
import ImpressionWatcher from 'js/utils/impressions/ImpressionWatcher';
import RedesignedMentionsPing from './redesigned_mentions_ping';

class RandomMentionPing extends RedesignedMentionsPing {
  getBody() {
    const article = $h.aOrAn(this.props.researchInterestName);
    return (
      <div className="text">
        The name <strong>{this.props.mentionedName}</strong> is mentioned in{' '}
        {article} <strong>{this.props.researchInterestName}</strong> paper
        uploaded to Academia.
      </div>
    );
  }

  getUpgradeURL() {
    return $r.upgrade_url({
      feature: 'searchm',
      trigger: 'random-mention-onsite-ping',
      after_upgrade_path: encodeURIComponent($r.mentions_path()),
    });
  }

  getCopyString() {
    const article = $h.aOrAn(this.props.researchInterestName);
    return `The name ${this.props.mentionedName} is mentioned in ${article} ${this.props.researchInterestName} paper uploaded to Academia.`;
  }

  render() {
    return (
      <ImpressionWatcher
        impressionId={this.props.pingId}
        entityType={0}
        source="random_mention_ping"
        extra={{
          researchInterestId: this.props.researchInterestId,
          copy: this.getCopyString(),
        }}
      >
        {super.render()}
      </ImpressionWatcher>
    );
  }
}

RandomMentionPing.propTypes = {
  pingId: PropTypes.string.isRequired,
  researchInterestId: PropTypes.number.isRequired,
  mentionedName: PropTypes.string.isRequired,
  researchInterestName: PropTypes.string.isRequired,
};

export default RandomMentionPing;
